import { Snackbar, Alert, Stack } from '@mui/material';
import { useAlerts, useUIStore } from '@/store';

/**
 * Alert/notification container component
 * Replaces Angular's ngx-toastr for non-toast alerts
 */
export const AlertContainer: React.FC = () => {
  const alerts = useAlerts();
  const removeAlert = useUIStore((state) => state.removeAlert);

  return (
    <Stack
      spacing={1}
      sx={{
        position: 'fixed',
        top: 16,
        right: 16,
        zIndex: (theme) => theme.zIndex.snackbar,
        maxWidth: 400,
      }}
    >
      {alerts.map((alert) => (
        <Snackbar
          key={alert.id}
          open={true}
          anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
          sx={{ position: 'relative', top: 0, right: 0 }}
        >
          <Alert
            severity={alert.severity}
            onClose={() => removeAlert(alert.id)}
            sx={{ width: '100%', boxShadow: 2 }}
          >
            {alert.message}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
};

export default AlertContainer;
